// Mock Data için Ortadoğu Ziraat Web Sitesi

export const companyInfo = {
  name: "Ortadoğu Ziraat A.Ş.",
  tagline: "Tohumdan Hasada, Güvenin Adresi",
  description: "Şanlıurfa'nın bereketli topraklarında, modern tarımın öncüsüyüz. Ortadoğu Seed markamızla Apache makarnalık buğday, Serche ekmeklik buğday ve Bonus pamuk tohumu ile çiftçimizin yanındayız.",
  address: "Beyazyaprak Mah. Akçakale Cd. No: 381/2 - Eyyübiye/Şanlıurfa",
  phone: "0414 503 06 78",
  whatsapp: "904145030678", // 90 ile başlayan format (uluslararası)
  email: "info@ortadoguziraat.com.tr",
  workingHours: "Pazartesi - Cumartesi: 08:00 - 18:00",
  mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3191.5624891445834!2d38.77385931526063!3d37.15950537988903!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1531dd7b7e7b3e8d%3A0x4f3c8c8c8c8c8c8c!2sBeyazyaprak%2C%20Ak%C3%A7akale%20Cd.%20No%3A381%2F2%2C%2063100%20Eyy%C3%BCbiye%2F%C5%9Eanl%C4%B1urfa!5e0!3m2!1str!2str!4v1699000000000!5m2!1str!2str",
  socialMedia: {
    facebook: "https://www.facebook.com/people/Ortadoğu-Ziraat-AŞ/61559498566555/",
    instagram: "https://www.instagram.com/ortadoguziraat",
    twitter: "https://x.com/ortadoguziraat",
    linkedin: "https://www.linkedin.com/in/ortadogu-ziraat-7b05311ba"
  },
  experience: 20,
  farmers: 1000,
  hectares: 50000,
  satisfaction: 98
};

export const heroSection = {
  title: "Tohumdan Hasada",
  subtitle: "Güvenin Adresi",
  description: "GAP bölgesinin lider tohum ve tarımsal girdi şirketi. Ortadoğu Seed markamızla Apache makarnalık buğday, Serche ekmeklik buğday ve Bonus pamuk tohumu ile yüksek verimli sertifikalı tohumlar.",
  ctaText: "Keşfetmeye Başlayın",
  ctaLink: "#services",
  backgroundImage: "https://images.unsplash.com/photo-1502395809857-fd80069897d0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwxfHxjb3R0b24lMjBmaWVsZHxlbnwwfHx8fDE3NjE5MTU0MjR8MA&ixlib=rb-4.1.0&q=85"
};

// Hero Slider için 3 slide verisi
export const heroSlides = [
  {
    id: 1,
    title: "Sertifikalı Tohumlar",
    subtitle: "Yüksek Verimli Ürünler",
    description: "Apache makarnalık buğday, Serche ekmeklik buğday ve Bonus pamuk tohumu - Bölge tarımına uygun sertifikalı tohumlar.",
    image: "https://images.unsplash.com/photo-1615671524775-85bd1c1d9cd3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxhZ3JpY3VsdHVyZSUyMHNlZWRzfGVufDB8fHx8MTc2MTkyMTIyOHww&ixlib=rb-4.1.0&q=85",
    ctaText: "Ürünlerimizi İnceleyin",
    ctaLink: "/tohumculuk"
  },
  {
    id: 2,
    title: "Bereketli Tarlalar",
    subtitle: "Kaliteli Hasat Zamanı",
    description: "Modern tarım teknikleri ve kaliteli girdilerle, GAP bölgesinde verimli üretim çözümleri sunuyoruz.",
    image: "https://images.unsplash.com/photo-1761069183877-fe29a212e5eb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwyfHxjb3R0b24lMjBmaWVsZCUyMGhhcnZlc3R8ZW58MHx8fHwxNzYxOTIxMjMzfDA&ixlib=rb-4.1.0&q=85",
    ctaText: "Hizmetlerimiz",
    ctaLink: "/urunler"
  },
  {
    id: 3,
    title: "Modern Tarım Teknolojisi",
    subtitle: "Geleceğin Tarımı",
    description: "Uzman kadromuz ve teknolojik çözümlerimizle çiftçilerimize 7/24 destek sağlıyoruz.",
    image: "https://images.unsplash.com/photo-1655131469140-136ba9ac89be?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwyfHx3aGVhdCUyMGZpZWxkfGVufDB8fHx5ZWxsb3d8MTc2MTkyNTc1MHww&ixlib=rb-4.1.0&q=85",
    ctaText: "Bize Ulaşın",
    ctaLink: "/iletisim"
  }
];

export const features = [
  {
    id: 1,
    title: "Sertifikalı Tohumlar",
    description: "Ar-Ge'den geçen, bölgeye adapte, yüksek verimli tohumlar",
    icon: "Award"
  },
  {
    id: 2,
    title: "Uzman Kadro",
    description: "Alanında deneyimli tarım mühendisleri ve agronomlar",
    icon: "Users"
  },
  {
    id: 3,
    title: "Kalite Güvencesi",
    description: "Her ürün sıkı kalite kontrolünden geçer",
    icon: "ShieldCheck"
  },
  {
    id: 4,
    title: "7/24 Destek",
    description: "Çiftçilerimize kesintisiz teknik destek",
    icon: "HeadphonesIcon"
  }
];

// Ürün Tedarikçileri / Ortaklarımız
export const productBrands = [
  {
    id: 1,
    name: "UPL",
    logo: "https://customer-assets.emergentagent.com/job_fce698d1-c0a7-4245-9c08-c8ebd3bd6cfb/artifacts/65f0dn21_upl-ortadogu-logo.jpg",
    url: "https://www.upl-ltd.com/tr/Ürün-portföyü",
    description: "Küresel çapta zirai ilaç ve tohumluk çözümleri"
  },
  {
    id: 2,
    name: "Genta Tarım",
    logo: "/genta-logo.png",
    url: "http://gentatarim.com/",
    description: "Kaliteli tohum ve tarımsal girdi sağlayıcısı"
  },
  {
    id: 3,
    name: "ProGen Seed",
    logo: "/progen-logo.png",
    url: "https://www.progenseed.com/",
    description: "Profesyonel tohum üretimi ve geliştirme"
  },
  {
    id: 4,
    name: "Nativi",
    logo: "/nativi-logo.png",
    url: "https://www.nativi.com.tr/",
    description: "Hasat sonrası koruma çözümleri"
  }
];

export const brands = [
  {
    id: 1,
    name: "Ortadoğu Seed",
    slug: "ortadogu-seed",
    tagline: "Toprağınızın İmzası",
    description: "Yüksek verimli, sertifikalı pamuk, mısır ve buğday tohumları. GAP bölgesinin iklim ve toprak yapısına özel geliştirilmiş çeşitler.",
    image: "https://images.unsplash.com/photo-1542990253-a781e04c0082?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwyfHxzZWVkc3xlbnwwfHx8fDE3NjE5MTU0NTV8MA&ixlib=rb-4.1.0&q=85",
    color: "from-emerald-600 to-green-700",
    icon: "Sprout"
  },
  {
    id: 2,
    name: "Akova Tarım",
    slug: "akova-tarim",
    tagline: "Çiftçimizin Güvenilir Ortağı",
    description: "2007 yılından bu yana zirai ilaç, tohum, gübre ve hububat sektöründe öncü. Nitelikli insan kaynağı ve güvene dayalı iş ilişkileri ile GAP bölgesinin lider tarım şirketi.",
    image: "https://customer-assets.emergentagent.com/job_farming-collab/artifacts/ngz4kotl_Hakk%C4%B1m%C4%B1zda%20B%C3%B6l%C3%BCm%C3%BC.jpg",
    color: "from-[#8AC73E] to-[#4A7C3A]",
    icon: "Building2"
  },
  {
    id: 3,
    name: "Akova Pamuk",
    slug: "akova-pamuk",
    tagline: "Dünya Pamuk Piyasasının Parlayan Yıldızı",
    description: "Modern çırçır tesisleri ile pamuk işleme ve tekstil hammaddesi üretimi. Bölgenin en büyük pamuk işleme kapasitesi.",
    image: "https://customer-assets.emergentagent.com/job_farming-collab/artifacts/u62smbyr_Tesis%20Havadan%20G%C3%B6r%C3%BCn%C3%BCm.png",
    color: "from-blue-600 to-indigo-700",
    icon: "Factory"
  }
];

export const services = [
  {
    id: 1,
    title: "Tohumculuk",
    subtitle: "Sertifikalı Yüksek Verimli Tohumlar",
    description: "GAP bölgesine özel geliştirilmiş, sertifikalı pamuk, mısır ve buğday tohumları. Yüksek verim garantisi ve kalite güvencesi ile çiftçimizin yanındayız.",
    features: ["Sertifikalı Tohumlar", "Yüksek Verim", "Bölgeye Özel"],
    image: "/tohumculuk-service.jpg",
    icon: "Sprout",
    color: "from-green-600 to-emerald-700",
    link: "/tohumculuk"
  },
  {
    id: 2,
    title: "Bitki Koruma",
    subtitle: "Hastalık ve Zararlılara Karşı Etkili Koruma",
    description: "Modern bitki koruma ürünleri ile tarlalarınızı hastalık, zararlı ve yabancı otlara karşı koruyun. Herbisit, fungisit ve insektisit çözümlerimizle güvenle üretin.",
    features: ["Herbisit Çözümleri", "Fungisit Uygulamaları", "İnsektisit Koruması"],
    image: "/bitki-koruma-service.jpg",
    icon: "Shield",
    color: "from-blue-600 to-cyan-700",
    link: "/urunler"
  },
  {
    id: 3,
    title: "Bitki Besleme",
    subtitle: "Verim Artırıcı Gübre ve Besleyici Çözümler",
    description: "Toprak analizi ile desteklenen, özel formülasyonlu gübreler ve bitki gelişim düzenleyiciler. Maksimum verim için dengeli beslenme programları.",
    features: ["Makro Besinler", "Mikro Elementler", "Özel Formülasyonlar"],
    image: "/bitki-besleme-service.jpg",
    icon: "Leaf",
    color: "from-amber-600 to-orange-700",
    link: "/urunler"
  }
];

export const seedProducts = [
  {
    id: 1,
    category: "Buğday Tohumları",
    categorySlug: "bugday",
    description: "Ekmeklik ve Makarnalık Buğday Çeşitleri",
    products: [
      { 
        id: 1, 
        name: "Serche", 
        yield: "Yüksek Verim", 
        features: ["Orta Erkenci", "Pas Hastalıklarına Toleranslı", "Protein %12.5-13.5", "Çok İyi Pişirme Kalitesi"], 
        image: "https://images.unsplash.com/photo-1654372031861-2d0d23635d77?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwyfHxnb2xkZW4lMjB3aGVhdCUyMGZpZWxkJTIwaGFydmVzdHxlbnwwfHx8eWVsbG93fDE3NjE5NDM4NDd8MA&ixlib=rb-4.1.0&q=85",
        brochure: "https://customer-assets.emergentagent.com/job_ziraat-web/artifacts/a3ij4rjj_Ortado%C4%9Fu-Seed-Serche.jpg",
        technicalDetails: {
          gelismeTabiati: "Alternatif",
          erkenlik: "Orta Erkenci",
          bitkiBoyu: "105-115 cm",
          hektolitre: "78-81 kg/hl",
          basak: "Kılçıklı",
          daneRengi: "Kırmızı",
          sertlik: "Yarı Sert",
          alveoEnerji: "300-450",
          extEnerji: "100-130",
          protein: "12.5-13.5%",
          gluten: "30-42%",
          pisirmeKalitesi: "Çok İyi"
        },
        description: "Güneydoğu Anadolu Bölgesi ile sahil kuşağı iklim ve toprak şartlarına uygun, yüksek verim ve kaliteye sahip ekmeklik buğday çeşidi. Dikim/ekim mesafesi, birim alana 25 kg/da tohumluk kullanılır."
      },
      { 
        id: 2, 
        name: "Apache", 
        yield: "Yüksek Verim", 
        features: ["Alternatif Gelişme", "Pas Hastalıklarına Toleranslı", "Protein %13-15", "Camsılık %90-95"], 
        image: "https://images.unsplash.com/photo-1655131469140-136ba9ac89be?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwyfHx3aGVhdCUyMGdyYWlufGVufDB8fHx5ZWxsb3d8MTc2MTk0Mzg1Nnww&ixlib=rb-4.1.0&q=85",
        brochure: "https://customer-assets.emergentagent.com/job_ziraat-web/artifacts/7wg58qqg_Ortado%C4%9Fu-Seed-Apache.jpg",
        technicalDetails: {
          gelismeTabiati: "Alternatif",
          erkenlik: "Orta",
          bitkiBoyu: "95-105 cm",
          hektolitre: "82-86 kg/hl",
          basak: "Mor Kılçıklı",
          daneRengi: "Kırmızı",
          protein: "13-15%",
          camsilik: "90-95%",
          bSiniflikDegeri: "19-24",
          kullanimAlani: "Makarna, İrmik, Bulgur"
        },
        description: "Güneydoğu Anadolu Bölgesi ile sahil kuşağı iklim ve toprak şartlarına uygun, yüksek verim ve kaliteye sahip makarnalık buğday çeşidi. Dikim/ekim mesafesi, birim alana 25 kg/da tohumluk kullanılır."
      }
    ],
    image: "https://images.unsplash.com/photo-1574323347407-f5e1ad6d020b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzl8MHwxfHNlYXJjaHwxfHx3aGVhdCUyMGZpZWxkfGVufDB8fHx5ZWxsb3d8MTc2MTk0MzgzN3ww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 2,
    category: "Pamuk Tohumları",
    categorySlug: "pamuk",
    description: "GAP Bölgesine Özel Pamuk Çeşitleri",
    products: [
      { 
        id: 3, 
        name: "Bonus", 
        yield: "Yüksek Verim", 
        features: ["Uzun Lif", "Hastalığa Dirençli", "Bölgeye Adapte", "Yüksek Çırçır Randımanı"], 
        image: "https://images.unsplash.com/photo-1502395809857-fd80069897d0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwxfHxjb3R0b24lMjBmaWVsZHxlbnwwfHx8fDE3NjE5MTU0MjR8MA&ixlib=rb-4.1.0&q=85",
        brochure: null,
        description: "GAP bölgesine özel geliştirilmiş, yüksek lif kalitesi ve verim potansiyeline sahip pamuk çeşidi. Bereketli topraklarda yüksek verim ve üstün kaliteyi hedefleyen çiftçilerimiz için özenle seçilmiş, güçlü ve dayanıklı tohum."
      }
    ],
    image: "https://images.unsplash.com/photo-1502395809857-fd80069897d0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwxfHxjb3R0b24lMjBmaWVsZHxlbnwwfHx8fDE3NjE5MTU0MjR8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 3,
    category: "Mısır Tohumları",
    categorySlug: "misir",
    description: "Yüksek Verimli Mısır Çeşitleri",
    comingSoon: true,
    products: [],
    image: "https://images.unsplash.com/photo-1601171908052-92d5a595199b"
  },
  {
    id: 4,
    category: "Arpa Tohumları",
    categorySlug: "arpa",
    description: "Yem ve Maltlık Arpa Çeşitleri",
    comingSoon: true,
    products: [],
    image: "https://images.unsplash.com/photo-1720113305313-bc33de6bf6a8"
  },
  {
    id: 5,
    category: "Mercimek Tohumları",
    categorySlug: "mercimek",
    description: "Kırmızı ve Yeşil Mercimek Çeşitleri",
    comingSoon: true,
    products: [],
    image: "https://images.unsplash.com/photo-1656342167250-bfadba5e4b73"
  },
  {
    id: 6,
    category: "Yonca Tohumları",
    categorySlug: "yonca",
    description: "Yem Bitkisi Yonca Çeşitleri",
    comingSoon: true,
    products: [],
    image: "https://images.unsplash.com/photo-1696912872450-9d340012ebc3"
  }
];

export const aboutContent = {
  title: "Ortadoğu Ziraat A.Ş.",
  subtitle: "GAP Bölgesi'nin Güvenilir Tarım Ortağı",
  foundingYear: "2015",
  foundingMonth: "Eylül",
  headquarters: "Şanlıurfa",
  serviceAreas: ["Şanlıurfa", "Gaziantep", "Malatya", "Elazığ", "Muş", "Van", "Diyarbakır", "Mardin", "Batman", "Siirt", "Silopi", "Suriye", "Irak"],
  mainProducts: ["Tohum", "Bitki Koruma", "Bitki Besleme", "Zirai İlaç"],
  
  history: "Ortadoğu Ziraat A.Ş., 2015 yılı Eylül ayında Şanlıurfa merkezli olarak faaliyetine başlamıştır. GAP Bölgesi'nin tarımsal potansiyelini değerlendirmek ve çiftçilerimize en kaliteli ürünleri sunmak vizyonuyla yola çıkan şirketimiz, kısa sürede bölgede güvenilir bir marka haline gelmiştir.",
  
  story: "Kurulduğumuz günden bu yana, bölge çiftçisinin yanında olan Ortadoğu Ziraat, tohum, bitki koruma, bitki besleme ve zirai ilaç alanlarında sunduğu geniş ürün yelpazesi ve kaliteli hizmet anlayışıyla fark yaratmaktadır. Modern tarım teknikleri ve geleneksel değerleri harmanlayan yaklaşımımızla, tarımsal üretimde verimliliği artırmayı ve çiftçilerimizin karlılığını maksimize etmeyi hedefliyoruz.",
  
  productRange: "Şirketimizin ürün portföyünde, ülkemizin ekolojik yapısına ve ürün çeşitliliğine uygun bitki koruma, bitki besleme ürünü, tohum ve zirai ilaç çeşitleri bulunmaktadır. Bu sayede sektöründe en geniş ürün yelpazesine sahip lider bir kuruluş olarak çiftçilerimizin ihtiyaç duyduğu tüm alanlarda hizmet vermekteyiz. Şirketimiz mevcut ürün yelpazesini geliştirirken, üreticilerin ihtiyaç ve beklentileri doğrultusunda, insana, çevreye ve doğaya saygılı, sürdürülebilir tarım uygulamalarına uygun ürünler sunmaktadır.",
  
  mission: [
    "Çiftçilerimize en iyi hizmeti verebilmek.",
    "Yüksek kaliteden ödün vermemek.",
    "Üreticilerimizin ürününün her türlü sorununa en etkili yöntemi kullanarak en kısa zamanda çözüm bulmak.",
    "Tüketiciye tarım ürünlerini en sağlıklı biçimde ulaşmasını sağlamak.",
    "Çözüm Ortaklarımızın yani Bayilerimizin taleplerini en kısa zamanda ve en doğru şekilde karşılayabilmek, kendimizi ve ortaklarımızı çiftçimize mahcup etmemek."
  ],
  
  vision: [
    "Tüm ürün çeşitlerimizi, önce Türk sonra Dünya çiftçilerine kolaylıkla ulaştırabilmek.",
    "Dünya'nın hemen hemen her yerinde yeni şubeler açmak.",
    "Dünya'daki her türlü bitkinin her tür sorununa en doğru çözüm bulmak. Buna göre en iyi ilaç markalarıyla çalışmak ve üretmek.",
    "Dünya'da, tarım alanında Türkiye'yi en iyi şekilde temsil edebilmek.",
    "Tüm Türk ve Dünya üreticisinin yüzünü güldürebilmek."
  ],
  
  values: [
    { 
      title: "Kalite Odaklılık", 
      description: "Her üründe ve hizmette en yüksek kalite standartlarını sağlamak", 
      icon: "Award" 
    },
    { 
      title: "Güvenilirlik", 
      description: "Çiftçilerimizin her zaman güvenebileceği istikrarlı bir partner olmak", 
      icon: "ShieldCheck" 
    },
    { 
      title: "Yenilikçilik", 
      description: "Modern tarım teknolojileri ile sürekli gelişim ve iyileştirme", 
      icon: "Lightbulb" 
    },
    { 
      title: "Sürdürülebilirlik", 
      description: "Çevre dostu ürünler ve uygulamalarla geleceği korumak", 
      icon: "Leaf" 
    },
    { 
      title: "Çiftçi Odaklılık", 
      description: "Çiftçilerimizin ihtiyaçlarını anlamak ve çözüm üretmek", 
      icon: "Users" 
    },
    { 
      title: "Bölgesel Gelişim", 
      description: "GAP Bölgesi'nin ekonomik kalkınmasına katkıda bulunmak", 
      icon: "TrendingUp" 
    }
  ],
  
  achievements: [
    {
      id: 1,
      year: "2015",
      title: "Kuruluş",
      description: "Şanlıurfa merkezli olarak faaliyete başladık"
    },
    {
      id: 2,
      year: "2017",
      title: "Bölgesel Genişleme",
      description: "Adıyaman, Mardin ve Diyarbakır illerinde hizmet vermeye başladık"
    },
    {
      id: 3,
      year: "2019",
      title: "Ürün Çeşitliliği",
      description: "Tohum, zirai ilaç ve gübre kategorilerinde 500+ ürün portföyüne ulaştık"
    },
    {
      id: 4,
      year: "2021",
      title: "5000+ Çiftçi",
      description: "GAP Bölgesi'nde 5000'den fazla çiftçiye hizmet vermeye başladık"
    },
    {
      id: 5,
      year: "2023",
      title: "Kalite Sertifikası",
      description: "ISO 9001 Kalite Yönetim Sistemi sertifikası aldık"
    },
    {
      id: 6,
      year: "2025",
      title: "Lider Konuma",
      description: "GAP Bölgesi'nin önde gelen tarım şirketleri arasında yerimizi aldık"
    }
  ],
  
  stats: [
    { label: "Kuruluş Yılı", value: "2015", icon: "Calendar" },
    { label: "Hizmet Bölgesi", value: "13", icon: "MapPin" },
    { label: "Mutlu Çiftçi", value: "5000+", icon: "Users" },
    { label: "Ürün Çeşidi", value: "500+", icon: "Package" }
  ],
  
  images: {
    hero: "https://customer-assets.emergentagent.com/job_agrisite-deploy/artifacts/v0eq0mfm_%C5%9Eanl%C4%B1urfa%20GAP%20B%C3%B6lgesi%20Tar%C4%B1m.jpg",
    timeline: "https://customer-assets.emergentagent.com/job_agrisite-deploy/artifacts/hrgaakbm_Tar%C4%B1msal%20Ba%C5%9Far%C4%B1%20ve%20B%C3%BCy%C3%BCme.jpg",
    products: "https://customer-assets.emergentagent.com/job_agrisite-deploy/artifacts/w79z1vfk_Ortado%C4%9Fu%20Seed%20Tohum%20Kalitesi.jpg",
    farmer: "https://customer-assets.emergentagent.com/job_agrisite-deploy/artifacts/z7d9zd2w_%C3%87ift%C3%A7i%20G%C3%BCven%20Ortakl%C4%B1k.jpg"
  }
};

// Team members section removed as per client request

export const projects = [
  {
    id: 1,
    title: "GAP Bölgesi Pamuk Projesi",
    description: "10,000 dekar alanda yüksek verimli pamuk üretimi",
    image: "https://images.unsplash.com/photo-1633554587766-ffc8151e31c0",
    year: "2024"
  },
  {
    id: 2,
    title: "Organik Buğday Üretimi",
    description: "Sürdürülebilir tarım uygulamaları ile organik üretim",
    image: "https://images.unsplash.com/photo-1551668705-ba19cebf56cd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwxfHx3aGVhdCUyMGZpZWxkfGVufDB8fHx5ZWxsb3d8MTc2MTk0NDYwM3ww&ixlib=rb-4.1.0&q=85",
    year: "2023"
  },
  {
    id: 3,
    title: "Mısır Hibrit Geliştirme",
    description: "Bölgeye özel yüksek verimli hibrit çeşitleri",
    image: "https://images.unsplash.com/photo-1554402100-8d1d9f3dff80",
    year: "2024"
  }
];

export const news = [
  {
    id: 1,
    title: "Yeni Pamuk Çeşidi ODS 103 Piyasada",
    excerpt: "Ar-Ge çalışmalarımızın sonucu yeni pamuk çeşidimiz çiftçilerimizle buluştu.",
    date: "15 Ekim 2024",
    image: "https://images.unsplash.com/photo-1502395809857-fd80069897d0",
    author: "Ayşe Demir"
  },
  {
    id: 2,
    title: "Tarım Fuarında Büyük İlgi",
    description: "Şanlıurfa Tarım Fuarı'nda standımızı 5000'den fazla çiftçi ziyaret etti.",
    date: "3 Ekim 2024",
    image: "https://images.unsplash.com/photo-1560493676-04071c5f467b",
    author: "Mehmet Kaya"
  },
  {
    id: 3,
    title: "Sürdürülebilir Tarım Sertifikası",
    excerpt: "Çevre dostu üretim yöntemlerimiz ile uluslararası sertifika aldık.",
    date: "20 Eylül 2024",
    image: "https://images.pexels.com/photos/348689/pexels-photo-348689.jpeg",
    author: "Ahmet Yılmaz"
  }
];

export const faqs = [
  {
    id: 1,
    question: "Tohumlarınızın çimlenme oranı ve randımanı nedir?",
    answer: "Tüm Ortadoğu Seed ürünleri Tarım ve Orman Bakanlığı tarafından sertifikalandırılmış olup, %99 çimlenme garantilidir. Buğday tohumlarımız hektar başına 600-700 kg/da, pamuk tohumlarımız ise 450-550 kg/da verim potansiyeline sahiptir. Bölgesel şartlara bağlı olarak verim değişiklik gösterebilir."
  },
  {
    id: 2,
    question: "Hangi gübre çeşitlerini öneriyorsunuz ve nasıl kullanmalıyım?",
    answer: "Toprak analizine göre özel gübre programları sunuyoruz. Genel olarak ekimde DAP veya kompoze gübre, kardeşlenme döneminde üre gübresi, sapa kalkma döneminde ise azot ve potasyum içerikli gübreler önermekteyiz. Dekara 20-25 kg DAP, 15-20 kg üre kullanımı ortalama önerilerimizdir. Detaylı bilgi için uzman ekibimizle iletişime geçebilirsiniz."
  },
  {
    id: 3,
    question: "Tohum ekimi için ideal süre ve toprak şartları nelerdir?",
    answer: "Buğday tohumları için Ekim-Kasım ayları, pamuk tohumları için Nisan-Mayıs ayları idealdir. Toprak sıcaklığının buğday için 5-8°C, pamuk için 15-18°C olması gerekir. İyi drenajlı, pH değeri 6.5-7.5 arası topraklar en uygunudur. Ekim derinliği buğday için 4-5 cm, pamuk için 3-4 cm olmalıdır."
  },
  {
    id: 4,
    question: "Tohumlarınızın hastalık direnci nasıldır?",
    answer: "Ürünlerimiz bölgeye özgü hastalıklara karşı yüksek tolerans gösterir. Apache ve Serche buğday çeşitlerimiz pas hastalıklarına toleranslıdır. Bonus pamuk çeşidimiz ise verticillium solgunluğuna ve fuzarium'a karşı dirençlidir. Yine de düzenli tarla kontrolleri ve gerektiğinde koruyucu ilaçlama önerilir."
  },
  {
    id: 5,
    question: "Teknik destek ve danışmanlık hizmeti veriyor musunuz?",
    answer: "Evet, uzman tarım mühendislerimiz ekimden hasada kadar tüm süreçte çiftçilerimize ücretsiz teknik destek ve danışmanlık hizmeti sağlamaktadır. Toprak analizi, gübreleme programı, hastalık teşhisi ve sulama planlaması konularında tam destek sunuyoruz."
  },
  {
    id: 6,
    question: "Ürünlerinizin fiyatları ve teslimat süresi nasıl?",
    answer: "Fiyatlarımız sezon ve sipariş miktarına göre değişkenlik göstermektedir. Toplu alımlarda özel indirimler uygulanmaktadır. Teslimat süremiz Şanlıurfa merkez ve çevre illerde 2-3 gün, diğer bölgelerde 5-7 gündür. Detaylı fiyat teklifi için lütfen bizimle iletişime geçin."
  }
];


// Ortadoğu Seed Company Page Content - SEO Optimized
export const ortadoguSeedContent = {
  hero: {
    title: "Ortadoğu Seed",
    tagline: "Toprağınızın İmzası",
    description: "GAP bölgesinin iklim ve toprak yapısına özel geliştirilmiş sertifikalı tohum üreticisi. Apache makarnalık buğday, Serche ekmeklik buğday ve Bonus pamuk tohumu ile yüksek verimli ve kaliteli hasatlar için güvenilir çözüm ortağınız.",
    foundingYear: "2010",
    logo: "https://customer-assets.emergentagent.com/job_repo-builder-28/artifacts/t46czy4s_Ortado%C4%9Fu-Seed-.png",
    image: "https://images.unsplash.com/photo-1542990253-a781e04c0082?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwyfHxzZWVkc3xlbnwwfHx8fDE3NjE5MTU0NTV8MA&ixlib=rb-4.1.0&q=85",
    stats: [
      { label: "Kuruluş Yılı", value: "2010" },
      { label: "Tohum Çeşidi", value: "3" },
      { label: "Çiftçi", value: "3K+" },
      { label: "Ekili Alan", value: "30K+ Ha" }
    ]
  },

  about: {
    title: "GAP Bölgesi'nin Güvenilir Tohum Üreticisi",
    content: [
      "Ortadoğu Seed, 2010 yılında GAP bölgesinin tarımsal potansiyelini en üst düzeyde değerlendirmek amacıyla kurulmuş, tohum üretimi ve dağıtımında uzmanlaşmış bir markadır. Bölgenin iklim ve toprak yapısına özel olarak geliştirilmiş Apache makarnalık buğday, Serche ekmeklik buğday ve Bonus pamuk tohumu çeşitlerimizle çiftçilerimize yüksek verimli, sertifikalı tohum çözümleri sunuyoruz.",
      "Yılların deneyimi ve bilimsel araştırma geliştirme çalışmalarımızla, GAP bölgesinde 30.000 hektardan fazla alanda 3.000'den fazla çiftçimize tohum tedarik eden güvenilir bir marka haline geldik. Her bir tohum çeşidimiz, uluslararası kalite standartlarında üretilmiş ve Tarım ve Orman Bakanlığı tarafından sertifikalandırılmıştır.",
      "Sadece tohum satışıyla yetinmeyen Ortadoğu Seed, çiftçilerimize ekim öncesi toprak analizi, ekim sırası teknik destek ve hasat sonrası verim analizi gibi kapsamlı danışmanlık hizmetleri de sunmaktadır. Amacımız, her çiftçimizin en yüksek verimi almasını sağlamak ve bölge tarımının sürdürülebilir gelişimine katkıda bulunmaktır."
    ],
    image: "https://images.unsplash.com/photo-1615671524775-85bd1c1d9cd3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxhZ3JpY3VsdHVyZSUyMHNlZWRzfGVufDB8fHx8MTc2MTkyMTIyOHww&ixlib=rb-4.1.0&q=85"
  },

  mission: "Ortadoğu Seed olarak misyonumuz, GAP bölgesinin iklim ve toprak şartlarına en uygun, yüksek verimli ve sertifikalı tohum çeşitlerini çiftçilerimize ulaştırarak bölge tarımının gelişimine katkıda bulunmak ve çiftçilerimizin refahını artırmaktır. Modern tarım teknolojileri ile geleneksel tarım bilgisini harmanlayarak, sürdürülebilir ve karlı üretim modellerini destekliyoruz.",

  products: [
    {
      name: "Apache",
      type: "Makarnalık Buğday",
      description: "GAP bölgesinin en yüksek verimli makarnalık buğday çeşidi. Yüksek protein oranı, mükemmel camsılık değeri ve üstün kalite özellikleri ile makarna sanayinin tercihi.",
      image: "https://images.unsplash.com/photo-1655131469140-136ba9ac89be?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwyfHx3aGVhdCUyMGdyYWlufGVufDB8fHx5ZWxsb3d8MTc2MTk0Mzg1Nnww&ixlib=rb-4.1.0&q=85",
      features: [
        "Protein oranı %13-15",
        "Camsılık %90-95",
        "Alternatif gelişme tabiatı",
        "Pas hastalıklarına toleranslı",
        "650-750 kg/da verim potansiyeli"
      ]
    },
    {
      name: "Serche",
      type: "Ekmeklik Buğday",
      description: "Sulu ve kuru koşullarda yüksek performans gösteren ekmeklik buğday çeşidi. Geniş adaptasyon yeteneği ve istikrarlı verim özellikleri ile öne çıkar.",
      image: "https://images.unsplash.com/photo-1509440159596-0249088772ff?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHx3aGVhdCUyMGZpZWxkfGVufDB8fHx5ZWxsb3d8MTc2MTk0MzgzN3ww&ixlib=rb-4.1.0&q=85",
      features: [
        "Yüksek hektolitre ağırlığı",
        "İyi ekmek yapım kalitesi",
        "Kışa dayanıklı",
        "Kuraklık toleransı yüksek",
        "600-700 kg/da verim potansiyeli"
      ]
    },
    {
      name: "Bonus",
      type: "Pamuk Tohumu",
      description: "GAP bölgesine özel geliştirilmiş, yüksek lif kalitesi ve çırçır randımanına sahip pamuk çeşidi. Hastalıklara dayanıklı ve yüksek verim potansiyeline sahip.",
      image: "https://images.unsplash.com/photo-1502395809857-fd80069897d0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwxfHxjb3R0b24lMjBmaWVsZHxlbnwwfHx8fDE3NjE5MTU0MjR8MA&ixlib=rb-4.1.0&q=85",
      features: [
        "Uzun lif yapısı (29-31 mm)",
        "Yüksek çırçır randımanı (%40-42)",
        "Verticillium solgunluğuna toleranslı",
        "Güçlü kök yapısı",
        "450-550 kg/da kütlü pamuk verimi"
      ]
    }
  ],

  advantages: [
    {
      title: "Sertifikalı Kalite",
      description: "Tüm tohumlarımız Tarım ve Orman Bakanlığı tarafından sertifikalandırılmış ve uluslararası kalite standartlarında üretilmiştir.",
      icon: "Award"
    },
    {
      title: "Bölgeye Özel Çeşitler",
      description: "GAP bölgesinin iklim ve toprak yapısına özel olarak seçilmiş ve test edilmiş tohum çeşitleri sunuyoruz.",
      icon: "Sprout"
    },
    {
      title: "Yüksek Verim Garantisi",
      description: "Doğru ekim teknikleri ve uygun koşullarda, ürünlerimiz %20-30 daha yüksek verim sağlar.",
      icon: "TrendingUp"
    },
    {
      title: "Teknik Destek",
      description: "Uzman ziraat mühendislerimizden ekimden hasada kadar her aşamada ücretsiz teknik destek alabilirsiniz.",
      icon: "Users"
    },
    {
      title: "Çevre Dostu Üretim",
      description: "Sürdürülebilir tarım uygulamaları ile üretilmiş, çevreye duyarlı tohum çeşitleri.",
      icon: "Leaf"
    },
    {
      title: "Güvenilir Tedarik Zinciri",
      description: "Kesintisiz stok ve hızlı teslimat ile ekim sezonunuzda yanınızdayız.",
      icon: "Handshake"
    }
  ],

  quality: {
    description: "Ortadoğu Seed olarak kalite, işimizin temel taşıdır. Üretimden paketlemeye kadar her aşamada katı kalite kontrol prosedürleri uygular, uluslararası standartlara uygunluğu titizlikle denetleriz. Tohumlarımız Tarım ve Orman Bakanlığı tarafından sertifikalandırılmış olup, her partide çimlenme gücü, genetik saflık ve fiziksel kalite testleri yapılmaktadır.",
    image: "https://images.unsplash.com/photo-1530836369250-ef72a3f5cda8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHxsYWJvcmF0b3J5JTIwcXVhbGl0eSUyMGNvbnRyb2x8ZW58MHx8fHwxNzYxOTIxMzI3fDA&ixlib=rb-4.1.0&q=85",
    certificates: [
      {
        name: "Tarım ve Orman Bakanlığı Sertifikası",
        description: "Tüm tohum çeşitlerimiz resmi sertifikalıdır ve tohum standartlarına uygunluğu garanti edilmiştir."
      },
      {
        name: "ISO 9001:2015 Kalite Yönetim Sistemi",
        description: "Üretim ve dağıtım süreçlerimiz uluslararası kalite standartlarında yönetilmektedir."
      },
      {
        name: "ISTA Uluslararası Tohum Test Birliği",
        description: "Laboratuvar analizlerimiz uluslararası tohum test standartlarına göre yapılmaktadır."
      },
      {
        name: "Gap-Seed Sertifika Programı",
        description: "GAP bölgesi için özel geliştirilmiş tohum kalite ve performans sertifikasyon programına üyeyiz."
      }
    ]
  },

  innovation: {
    description: "Ortadoğu Seed, sürekli araştırma geliştirme faaliyetleri ile tohum teknolojisinde yeniliklere öncülük eder. Yerli ve yabancı araştırma kuruluşları ile işbirliği içinde, bölge koşullarına daha iyi adapte olan, daha verimli ve dayanıklı yeni çeşitlerin geliştirilmesi için çalışıyoruz.",
    areas: [
      {
        title: "Çeşit Geliştirme",
        description: "GAP bölgesinin spesifik iklim ve toprak koşullarına uygun yeni tohum çeşitleri geliştirmek için genetik ıslah çalışmaları yürütüyoruz."
      },
      {
        title: "Hastalık Direnci",
        description: "Bölgede yaygın görülen bitki hastalıklarına karşı dayanıklı tohum hatları geliştirerek kimyasal kullanımını azaltıyoruz."
      },
      {
        title: "Kuraklık Toleransı",
        description: "İklim değişikliğine karşı dirençli, az suyla yüksek verim alabilen tohum çeşitleri üzerinde çalışıyoruz."
      },
      {
        title: "Verim Optimizasyonu",
        description: "Büyük veri analitiği ve yapay zeka destekli modelleme ile tohum performansını artırmaya yönelik Ar-Ge çalışmaları yapıyoruz."
      }
    ]
  },

  impact: {
    stats: [
      { label: "Ekili Alan", value: "30K+ Ha" },
      { label: "Çiftçi", value: "3000+" },
      { label: "Toplam Üretim", value: "180K+ Ton" },
      { label: "İhracat", value: "12 Ülke" }
    ],
    highlight: {
      title: "Bölgesel Kalkınmaya Katkımız",
      description: "Ortadoğu Seed tohumları ile üretim yapan çiftçilerimiz, geleneksel yöntemlere göre ortalama %25 daha yüksek verim elde etmekte ve bölge ekonomisine yıllık 50 milyon TL'nin üzerinde katma değer sağlamaktadır."
    }
  },

  sustainability: {
    initiatives: [
      {
        title: "Su Tasarrufu",
        description: "Geliştirdiğimiz kuraklığa dayanıklı tohum çeşitleri sayesinde, bölgede sulama suyu tüketimi %15 azaltılmıştır."
      },
      {
        title: "Kimyasal Kullanımının Azaltılması",
        description: "Hastalığa dirençli çeşitler sayesinde, çiftçilerimiz %30 daha az zirai ilaç kullanarak hem maliyetlerini düşürmekte hem de çevreyi korumaktadır."
      },
      {
        title: "Toprak Sağlığı",
        description: "Tohumlarımızın gelişmiş kök yapısı sayesinde toprak erozyonu azalmakta ve toprak organik maddesi artmaktadır."
      },
      {
        title: "Çiftçi Eğitimi",
        description: "Yılda 500+ çiftçiye sürdürülebilir tarım uygulamaları, doğru tohum seçimi ve modern yetiştirme teknikleri konularında ücretsiz eğitim veriyoruz."
      },
      {
        title: "Yerel İstihdam",
        description: "Bölgedeki tohum üretimi, paketleme ve dağıtım faaliyetlerimiz ile 200'den fazla kişiye doğrudan istihdam sağlıyoruz."
      }
    ]
  }
};

